import { useEffect } from 'react';
import {
	DASHBOARD_HOME_NAVBAR_HIDDEN_CLASS,
	DASHBOARD_HOME_SCROLL_TOP_THRESHOLD,
} from '../utils/dashboardHomeMobileScroll';

const NAVBAR_HIDDEN_CLASS = DASHBOARD_HOME_NAVBAR_HIDDEN_CLASS;
const SCROLL_TOP_SHOW = DASHBOARD_HOME_SCROLL_TOP_THRESHOLD;
const SCROLL_HIDE_AT = 28;
const SCROLL_UP_SHOW_DELTA = 6;

const setNavbarHidden = (hidden) => {
	document.body.classList.toggle(NAVBAR_HIDDEN_CLASS, hidden);
};

/** 手机首页：绑定 DashboardHomeMobileShell 滚动容器，向下滑收起顶栏 */
export function useDashboardHomeMobileNavbarScroll(scrollEl) {
	useEffect(() => {
		if (!scrollEl) {
			return undefined;
		}

		let lastScrollY = Math.max(0, scrollEl.scrollTop);
		let hidden = document.body.classList.contains(NAVBAR_HIDDEN_CLASS);

		const apply = () => {
			const scrollY = Math.max(0, scrollEl.scrollTop);
			const delta = scrollY - lastScrollY;

			if (scrollY <= SCROLL_TOP_SHOW) {
				hidden = false;
			} else if (scrollY >= SCROLL_HIDE_AT) {
				hidden = true;
			} else if (delta < -SCROLL_UP_SHOW_DELTA) {
				hidden = false;
			}

			setNavbarHidden(hidden);
			lastScrollY = scrollY;
		};

		apply();
		scrollEl.addEventListener('scroll', apply, { passive: true });

		const onTouchEnd = () => {
			window.requestAnimationFrame(apply);
		};
		scrollEl.addEventListener('touchend', onTouchEnd, { passive: true });
		scrollEl.addEventListener('touchcancel', onTouchEnd, { passive: true });

		return () => {
			scrollEl.removeEventListener('scroll', apply);
			scrollEl.removeEventListener('touchend', onTouchEnd);
			scrollEl.removeEventListener('touchcancel', onTouchEnd);
			document.body.classList.remove(NAVBAR_HIDDEN_CLASS);
		};
	}, [scrollEl]);
}
